import { gql } from '@apollo/client';

export const ADD_UPDATE_FINANCIAL_PRODUCT_RULE = gql`
  mutation addOrUpdateFinancialProductRule($input: FinancialProductRuleEditItemInput) {
    addOrUpdateFinancialProductRule(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const ADD_UPDATE_FINANCIAL_PRODUCT_RULE_OUTPUT_DATA = gql`
  mutation addOrUpdateFinancialProductRuleOutputData($input: FinancialProductRuleOutputDataInput) {
    addOrUpdateFinancialProductRuleOutputData(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const REMOVE_FINANCIAL_PRODUCT_RULE_OUTPUT_DATA = gql`
  mutation deleteFinancialProductRuleOutputData($input: DeleteFinancialProductRuleOutputDataInput) {
    deleteFinancialProductRuleOutputData(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const ADD_UPDATE_FINANCIAL_PRODUCT_RULE_OUTPUT_DICTIONARY = gql`
  mutation addOrUpdateFinancialProductRuleOutputDictionary($input: FinancialProductRuleOutputDictionaryInput) {
    addOrUpdateFinancialProductRuleOutputDictionary(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const REMOVE_FINANCIAL_PRODUCT_RULE_OUTPUT_DICTIONARY = gql`
  mutation deleteFinancialProductRuleOutputDictionary($input: DeleteFinancialProductRuleOutputDictionaryInput) {
    deleteFinancialProductRuleOutputDictionary(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const ADD_UPDATE_FINANCIAL_PRODUCT_RULE_COMMISSION = gql`
  mutation addOrUpdateFinancialProductRuleCommission($input: FinancialProductRuleCommissionInput) {
    addOrUpdateFinancialProductRuleCommission(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const REMOVE_FINANCIAL_PRODUCT_RULE_COMMISSION = gql`
  mutation deleteFinancialProductRuleCommission($input: DeleteFinancialProductRuleCommissionInput) {
    deleteFinancialProductRuleCommission(input: $input) {
      commandId
      correlationId
    }
  }
`;


export const ADD_UPDATE_FINANCIAL_PRODUCT_RULE_SERVICE = gql`
  mutation addOrUpdateFinancialProductRuleService($input: FinancialProductRuleServiceInput) {
    addOrUpdateFinancialProductRuleService(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const REMOVE_FINANCIAL_PRODUCT_RULE_SERVICE = gql`
  mutation deleteFinancialProductRuleService($input: DeleteFinancialProductRuleServiceInput) {
    deleteFinancialProductRuleService(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const ADD_UPDATE_FINANCIAL_PRODUCT_RULE_INCOME = gql`
  mutation addOrUpdateFinancialProductRuleIncome($input: FinancialProductRuleIncomeInput) {
    addOrUpdateFinancialProductRuleIncome(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const REMOVE_FINANCIAL_PRODUCT_RULE_INCOME = gql`
  mutation deleteFinancialProductRuleIncome($input: DeleteFinancialProductRuleIncomeInput) {
    deleteFinancialProductRuleIncome(input: $input) {
      commandId
      correlationId
    }
  }
`;